import { render, staticRenderFns } from "./storico_modifiche_adesione.vue?vue&type=template&id=2e8d57e6&"
import script from "./storico_modifiche_adesione.vue.ts?vue&type=script&lang=ts&"
export * from "./storico_modifiche_adesione.vue.ts?vue&type=script&lang=ts&"
import style0 from "./storico_modifiche_adesione.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports